import { useCallback, useState } from "react";
import { useImageCreateMutation } from "@ticketingplatform/api/dist/image";

import { UseUploadReturnType } from "./types";

const useImageUpload = (): UseUploadReturnType => {
  const [loading, setLoading] = useState(false);
  const [createImage] = useImageCreateMutation();

  return {
    isUploadLoading: loading,
    uploadImage: useCallback(
      async (image) => {
        setLoading(true);

        try {
          if (image.size === undefined || !image.type) {
            throw new Error("Invalid image. Size or type is missing.");
          }

          const { data } = await createImage({
            variables: {
              input: {
                name: image.name,
                size: image.size,
                type: image.type,
              },
            },
          });

          if (!data?.imageCreate) {
            throw new Error("Failed to upload image");
          }

          const response = await fetch(data.imageCreate.uploadUrl, {
            body: image.originFileObj,
            method: "PUT",
          });

          if (!response.ok) {
            throw new Error("Failed to upload image");
          }

          return data?.imageCreate;
        } finally {
          setLoading(false);
        }
      },
      [createImage]
    ),
  };
};

export default useImageUpload;
